import React from "react";
import { Outlet } from "react-router-dom";

const VesselNominationPage: React.FC = () => {
  return (
    <div data-testid="vessel-nomination">
      <Outlet />
    </div>
  );
};

export default VesselNominationPage;
